import axios from 'axios'
import { getUrlParams } from '@/utils/url'
import App from '../main.js'

const { lang, campground } = getUrlParams()

let TOKEN = null

// exposing HTTP is needed for mocking in tests
export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT.replace('{lang}', lang),
})

/* istanbul ignore next */
HTTP.interceptors.request.use(config => {
  App.$Progress.start() // for every request start the progress
  return config
})

/* istanbul ignore next */
HTTP.interceptors.response.use(response => {
  App.$Progress.finish() // finish when a response is received
  return response
})

// exposed api
export const Api = {
  getCampgroundData: language => getCampgroundData(language),
  getData: (url, params) => getData(url, params),
  postData: (url, params) => postData(url, params),
  setToken: token => {
    TOKEN = token
  },
}

const getCampgroundData = async (language = null) => {
  HTTP.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT.replace('{lang}', language || lang)
  const result = await HTTP.get(`/checkout-data/${campground}/`, getConfigWithToken()).catch(
    error => onError(error)
  )
  return result.data
}

const getData = async (url, params = {}) => {
  const result = await HTTP.get(url, getConfigWithToken(params)).catch(error => onError(error))
  return result.data
}

const postData = async (url, params = {}) => {
  if (TOKEN) {
    let tokenParam = `token=${encodeURIComponent(TOKEN)}`
    if (url.indexOf('?') !== -1) {
      url += `&${tokenParam}`
    } else {
      url += `?${tokenParam}`
    }
  }

  const result = await HTTP.post(url, params).catch(error => onError(error))
  return result.data
}

// on error function
const onError = error => {
  console.warn(error)
  throw error
}

const getConfigWithToken = (config = null) => {
  if (!TOKEN) {
    return config
  }

  if (!config) {
    config = {}
  }

  if (!config.params) {
    config.params = {}
  }

  config.params.token = TOKEN
  return config
}
